// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "* { line-height: 1; display:block;}", "",{"version":3,"sources":["webpack://./src/app/pages/account/comercial/clientes/clientes.component.ts"],"names":[],"mappings":"AAAA,IAAI,cAAc,EAAE,aAAa,CAAC","sourcesContent":["* { line-height: 1; display:block;}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
